const TOKEN = /^[A-Za-z0-9_-]{32}$/;
const KEY = "cb_room_invite";
function availableStorage() {
  try { return typeof window === "undefined" ? null : window.sessionStorage; } catch (error) { return null; }
}

export function validRoomToken(value) {
  return typeof value === "string" && TOKEN.test(value);
}

/** Navigation intent only: bunker remains the authority for membership. */
export function roomTokenFromLaunch({ search = "", initData = "", startParam = "" } = {}) {
  const query = new URLSearchParams(search);
  const signedParam = new URLSearchParams(initData).get("start_param");
  const payload = signedParam || startParam || query.get("tgWebAppStartParam") || "";
  const token = payload.startsWith("room_") ? payload.slice(5) : query.get("room") || query.get("invite");
  return validRoomToken(token) ? token : null;
}

export function rememberRoomIntent(token, storage = availableStorage()) {
  if (!validRoomToken(token)) return false;
  try { storage?.setItem(KEY, token); } catch (error) { /* Store retains the memory fallback. */ }
  return true;
}

export function savedRoomIntent(storage = availableStorage()) {
  try {
    const token = storage?.getItem(KEY);
    return validRoomToken(token) ? token : null;
  } catch (error) { return null; }
}

export function clearRoomIntent(storage = availableStorage()) {
  try { storage?.removeItem(KEY); } catch (error) { /* Storage may be disabled in a WebView. */ }
}

export function roomInviteLink(token, bot = "", origin = "") {
  if (!validRoomToken(token)) return "";
  const username = String(bot).trim().replace(/^@/, "");
  return username ? `https://t.me/${username}?startapp=room_${token}` : `${origin}/?room=${token}`;
}

export function requestId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  return `room-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}
